import api from '../../../utils/api';

export default new class Ajax {
    getUsers() {
        return api.get(`/api/admin-panel`).then(({data}) => data);
    }
}